import { render, staticRenderFns } from "./addPvFieldsButtonAndModal.vue?vue&type=template&id=e4a78a24&"
import script from "./addPvFieldsButtonAndModal.vue?vue&type=script&lang=js&"
export * from "./addPvFieldsButtonAndModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports